import Layers from '../ILayers'
import ol from 'openlayers'

class _KMLLayer extends Layers {

	constructor(obj) {
		super()
		this.obj = obj
		this.kmlFormatWater = new ol.format.KML({
			extractStyles: obj.extractStyles || false
		})
		this.layer = this.createLayer()
	}

	createLayer() {
		const vct = new ol.source.Vector({
			url: this.obj.url,
			format: this.kmlFormatWater
		})
		return new ol.layer.Vector({
			source: vct,
			style: this.obj.style
		})
	}

	getLayer() {
		return this.layer
	}

	getPopup() {
		return this.popup
	}

}

export default function KMLLayer(args) {
	return new _KMLLayer(args)
}



// WEBPACK FOOTER //
// ./src/utils/mapUtils/layers/KMLLayer.js